import { ArrowSquareOut, HourglassMedium, Storefront } from "@phosphor-icons/react";
import ModalCloseButton from "../ui/ModalCloseButton";
import "./GrowIntegration.css";

/**
 * GrowPartnerOnboarding — "פתיחת חשבון Grow" via CliniKit as a platform partner.
 *
 * SCAFFOLD. The embedded registration form / hand-off spec is **[ASK GROW]**
 * (grow_integration.md §10 #5). Until Grow answers, this opens the signup URL
 * from `REACT_APP_GROW_PARTNER_SIGNUP_URL` in a new tab (or shows "בקרוב" when
 * empty). The "ממתין לאישור" state is server-owned
 * (`clinic.growIntegration.partnerStatus === "pending"`, set by a NiV tool in
 * Phase 8 when Grow confirms the merchant) — this component only renders it.
 *
 * Shown only when `clinic.growIntegration?.partnerFlowEnabled === true` (NiV flag).
 */
export default function GrowPartnerOnboarding({ isOpen, onClose, partnerStatus = null }) {
  if (!isOpen) return null;
  const signupUrl = process.env.REACT_APP_GROW_PARTNER_SIGNUP_URL || "";
  const pending = partnerStatus === "pending";

  return (
    <div className="grow-overlay" onClick={onClose} role="presentation">
      <div className="grow-modal grow-modal-sm" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true" aria-labelledby="grow-partner-title">
        <div className="grow-modal-header">
          <div className="grow-modal-title">
            <span className="grow-modal-icon"><Storefront size={20} weight="fill" /></span>
            <div>
              <span className="grow-eyebrow">Grow</span>
              <h3 id="grow-partner-title">פתיחת חשבון Grow דרך CliniKit</h3>
            </div>
          </div>
          <ModalCloseButton onClick={onClose} />
        </div>

        <div className="grow-modal-body">
          {pending ? (
            <div className="grow-callout">
              <HourglassMedium size={18} weight="fill" />
              <span>הבקשה נשלחה ל-Grow וממתינה לאישור. כשהחשבון יאושר, החיבור יושלם אוטומטית ותקבלו הודעה.</span>
            </div>
          ) : (
            <>
              <p>פותחים חשבון סליקה ב-Grow בכמה דקות. בסיום ההרשמה Grow מעבירים אלינו את מזהי העסק והחיבור מושלם ללא הדבקה ידנית.</p>
              <ul className="grow-bullets">
                <li>אשראי, Bit, Apple Pay ו-Google Pay בעמוד תשלום אחד</li>
                <li>קבלה אוטומטית לכל תשלום</li>
                <li>הכסף מגיע ישירות לחשבון הבנק של הקליניקה</li>
              </ul>
              {!signupUrl && (
                <p className="grow-note">ההרשמה המשולבת תיפתח בקרוב. בינתיים אפשר לפתוח חשבון ישירות באתר Grow ולחבר אותו ב"יש לי חשבון Grow".</p>
              )}
            </>
          )}
        </div>

        <div className="grow-modal-footer">
          <div className="grow-footer-actions">
            <button type="button" className="grow-btn secondary" onClick={onClose}>סגירה</button>
            {!pending && signupUrl && (
              <a className="grow-btn primary" href={signupUrl} target="_blank" rel="noreferrer">
                <ArrowSquareOut size={16} /> המשך להרשמה ב-Grow
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
